import {
  Component,
  ComponentFactoryResolver,
  AfterViewInit,
  Input,
  OnChanges,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {
  DwComponentType,
  DwQueryFilterGroup,
  DwUiConfigRegistryService
} from '@devwareapps/devware-cap';
import { ReportWidgetDefinition } from '../../models/report-dashboard-definition.model';

@Component({
  selector: 'app-report-custom-widget-host',
  template: '<ng-template #widgetHost></ng-template><div class="text-muted" *ngIf="errorMessage">{{ errorMessage }}</div>'
})
export class ReportCustomWidgetHostComponent implements OnChanges, AfterViewInit {
  @Input() definition: ReportWidgetDefinition;
  @Input() filters: DwQueryFilterGroup;
  @Input() expressionContext: any;
  @ViewChild('widgetHost', { read: ViewContainerRef, static: true }) widgetHost: ViewContainerRef;

  errorMessage: string;

  constructor(
    private registry: DwUiConfigRegistryService,
    private componentFactoryResolver: ComponentFactoryResolver
  ) { }

  ngOnChanges(): void {
    this.render();
  }

  ngAfterViewInit(): void {
    this.render();
  }

  private render(): void {
    if (!this.widgetHost || !this.definition?.componentName) {
      return;
    }

    this.widgetHost.clear();
    this.errorMessage = null;
    const reference = this.registry.getRegisteredComponent(
      this.definition.componentName,
      [DwComponentType.card, DwComponentType.pageDesignSection],
      true
    );

    if (!reference?.component) {
      this.errorMessage = `Custom widget component is not registered: ${this.definition.componentName}`;
      return;
    }

    const factory = this.componentFactoryResolver.resolveComponentFactory(reference.component);
    const componentRef = this.widgetHost.createComponent(factory);
    const instance: any = componentRef.instance;
    instance.definition = this.definition;
    instance.config = this.definition.componentConfig || reference.configData;
    instance.filters = this.filters;
    instance.expressionContext = this.expressionContext;
    componentRef.changeDetectorRef.detectChanges();
  }
}
